import illustrationRetina from 'marketing-website/media/images/pages/account-locked/builder-user@2x.png';

const assets = {
  illustration: {
    alt: 'Account locked contact sales',
    src: illustrationRetina,
    maxWidth: 359,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/account-locked/assets.js